import React, { useState, useEffect } from 'react';
import PhotoCapture from './PhotoCapture';
import './LogEntryForm.css';

function LogEntryForm({ onSubmit, onCancel, currentQuantities }) {
  const [notes, setNotes] = useState('');
  const [photos, setPhotos] = useState([]);
  const [error, setError] = useState('');
  const [showQuantities, setShowQuantities] = useState(false);
  const [quantities, setQuantities] = useState({
    qtyPlugs: 0,
    qtySoloCups: 0,
    qtyQuarts: 0,
    qtyGallons: 0,
  });

  // Sync from prop when it arrives or changes
  useEffect(() => {
    if (currentQuantities) {
      const q = {
        qtyPlugs: currentQuantities.qtyPlugs ?? 0,
        qtySoloCups: currentQuantities.qtySoloCups ?? 0,
        qtyQuarts: currentQuantities.qtyQuarts ?? 0,
        qtyGallons: currentQuantities.qtyGallons ?? 0,
      };
      setQuantities(q);
      const total = q.qtyPlugs + q.qtySoloCups + q.qtyQuarts + q.qtyGallons;
      if (total > 0) setShowQuantities(true);
    }
  }, [currentQuantities]);

  const handlePhotoCaptured = (files) => {
    setPhotos(files);
    if (files.length > 0) {
      setError('');
    }
  };

  const handleQtyChange = (field, value) => {
    setQuantities((prev) => ({ ...prev, [field]: parseInt(value, 10) || 0 }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    const payload = { notes, photos };
    if (showQuantities) {
      payload.quantities = quantities;
    }
    onSubmit(payload);
  };

  return (
    <form className="log-entry-form" onSubmit={handleSubmit} noValidate>
      <h2 className="log-entry-form__title">New Log Entry</h2>

      <div className="log-entry-form__field">
        <label htmlFor="log-notes" className="log-entry-form__label">
          Notes (optional)
        </label>
        <textarea
          id="log-notes"
          className="log-entry-form__textarea"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Add notes about this observation..."
        />
      </div>

      <div className="log-entry-form__field">
        <PhotoCapture onPhotoCaptured={handlePhotoCaptured} multiple={true} />
        {error && (
          <p className="log-entry-form__error" role="alert">
            {error}
          </p>
        )}
      </div>

      <div className="log-entry-form__qty-section">
        <button
          type="button"
          className="log-entry-form__qty-toggle"
          onClick={() => setShowQuantities(!showQuantities)}
        >
          {showQuantities ? '▾ Update Quantities' : '▸ Update Quantities'}
        </button>

        {showQuantities && (
          <div className="log-entry-form__qty-fields">
            <div className="log-entry-form__qty-row">
              <label htmlFor="log-qty-plugs">Plugs</label>
              <input id="log-qty-plugs" type="number" min="0" value={quantities.qtyPlugs} onChange={(e) => handleQtyChange('qtyPlugs', e.target.value)} />
            </div>
            <div className="log-entry-form__qty-row">
              <label htmlFor="log-qty-solo">Solo Cups</label>
              <input id="log-qty-solo" type="number" min="0" value={quantities.qtySoloCups} onChange={(e) => handleQtyChange('qtySoloCups', e.target.value)} />
            </div>
            <div className="log-entry-form__qty-row">
              <label htmlFor="log-qty-quarts">Quarts</label>
              <input id="log-qty-quarts" type="number" min="0" value={quantities.qtyQuarts} onChange={(e) => handleQtyChange('qtyQuarts', e.target.value)} />
            </div>
            <div className="log-entry-form__qty-row">
              <label htmlFor="log-qty-gallons">Gallons</label>
              <input id="log-qty-gallons" type="number" min="0" value={quantities.qtyGallons} onChange={(e) => handleQtyChange('qtyGallons', e.target.value)} />
            </div>
          </div>
        )}
      </div>

      <div className="log-entry-form__actions">
        <button type="submit" className="log-entry-form__btn log-entry-form__btn--submit">
          Save Entry
        </button>
        <button
          type="button"
          className="log-entry-form__btn log-entry-form__btn--cancel"
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </form>
  );
}

export default LogEntryForm;
